import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../Home/Home';
import ProductList from '../ProductList/ProductList';
import ProductDetails from '../ProductDetails/ProductDetails';
import ComboDetails from '../ComboDetails/ComboDetails';
import AddToCart from '../AddToCart/AddToCart';
import Checkout from '../Checkout/Checkout';
import Signup from '../Register/Signup';
import Signin from '../Register/Signin';
import Profile from '../Profile/Profile';
import WishList from '../WishList/WishList';
import Orders from '../Orders/Orders';
import OrderDetails from '../Orders/OrderDetails';
import Policies from '../Policies/Policies';
import FAQs from '../FAQs/FAQs';
import Subcategory from '../Subcategory/Subcategory';
import Rewards from '../Rewards/Rewards';
import Notification from '../Notification/Notification';
import ForgotPasswordPage from '../../Components/ForgotpasswordPage/ForgotPasswordPage';
import NotFound from '../NotFound/NotFound';
import PolicyDetail from '../Policies/PolicyDetail';
import ProtectedRoute from '../../Components/ProtectedRoute/ProtectedRoute';
import ShortLinkRedirect from '../ShortLinkRedirect/ShortLinkRedirect';
import Support from '../Support/Support';
import TicketDetails from '../Support/TicketDetails';

import ComboList from '../ComboList/ComboList';
import BogoList from '../BogoList/BogoList';
import BogoDetails from '../BogoDetails/BogoDetails';

const MainRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/s/:shortId" element={<ShortLinkRedirect />} />
      {/* Dynamic route for category product list pages, e.g. /hair-care/Shampoo */}
      <Route path="/:category/:subcategory" element={<ProductList />} />
      <Route path="/search" element={<ProductList />} />
      <Route path="/products" element={<ProductList />} />
      <Route path="/combos" element={<ComboList />} />
      <Route path="/bogo-deals" element={<BogoList />} />
      <Route path="/bogo-deal/:id" element={<BogoDetails />} />

      {/* Product details route */}
      <Route path="/product/:id" element={<ProductDetails />} />
      <Route path="/combo-details/:id" element={<ComboDetails />} />
      {/* Add to cart route */}
      <Route path="/addtocart" element={<AddToCart />} />
      <Route path="/checkout" element={<Checkout />} />
      {/* customers (B2C) are the default; businesses (B2B) have their own pages */}
      <Route path="/signup" element={<Signup mode="customer" />} />
      <Route path="/signin" element={<Signin mode="customer" />} />
      <Route path="/business/signup" element={<Signup mode="business" />} />
      <Route path="/business/signin" element={<Signin mode="business" />} />

      {/* Protected Routes */}
      <Route path='/profile' element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path='/wishlist' element={<ProtectedRoute><WishList /></ProtectedRoute>} />
      <Route path='/orders' element={<ProtectedRoute><Orders /></ProtectedRoute>} />
      <Route path='/orderdetails/:id' element={<ProtectedRoute><OrderDetails /></ProtectedRoute>} />
      <Route path='/policies' element={<Policies />} />
      <Route path='/faqs' element={<FAQs />} />
      <Route path='/support' element={<Support />} />
      <Route path='/support/ticket/:id' element={<ProtectedRoute><TicketDetails /></ProtectedRoute>} />

      {/* Specific static routes MUST come before dynamic /:category route */}
      <Route path='/terms-and-conditions' element={<PolicyDetail />} />
      <Route path='/privacy-policy' element={<PolicyDetail />} />
      <Route path='/refund-policy' element={<PolicyDetail />} />
      <Route path='/return-policy' element={<PolicyDetail />} />
      <Route path='/return-refund-policy' element={<PolicyDetail />} />
      <Route path='/shipping-policy' element={<PolicyDetail />} />
      <Route path='/payment-policy' element={<PolicyDetail />} />
      <Route path='/cancellation-policy' element={<PolicyDetail />} />
      <Route path='/user-account-policy' element={<PolicyDetail />} />
      <Route path='/user-policy' element={<PolicyDetail />} />
      <Route path='/liability-limitation' element={<PolicyDetail />} />
      
      {/* Dynamic param for any existing URLs using /policy/:type */}
      <Route path='/policy/:type' element={<PolicyDetail />} />
      <Route path='/rewards' element={<Rewards />} />
      <Route path='/notification' element={<Notification />} />
      <Route path='/reset-password/:token' element={<ForgotPasswordPage />} />

      {/* Dynamic category route */}
      <Route path='/:category' element={<Subcategory />} />

      {/* 404 Page Route - Catch all unmatched paths */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};


export default MainRoutes;
